import React, { useEffect, useState } from "react";
import { Input } from "./ui/input";

export function formatDob(raw) {
  const d = (raw || "").replace(/\D/g, "").slice(0, 8);
  if (d.length <= 2) return d;
  if (d.length <= 4) return `${d.slice(0, 2)}/${d.slice(2)}`;
  return `${d.slice(0, 2)}/${d.slice(2, 4)}/${d.slice(4)}`;
}

export function DobInput({ value, onChange, testid, className = "h-12 text-base", id = "dob" }) {
  const [v, setV] = useState(formatDob(value));
  useEffect(() => { setV(formatDob(value)); }, [value]);
  return (
    <Input id={id} data-testid={testid} value={v} inputMode="numeric" placeholder="MM/DD/YYYY" className={className}
      onChange={(e) => { const f = formatDob(e.target.value); setV(f); onChange(f); }} />
  );
}

export function computeAge(dob) {
  const s = (dob || "").trim();
  let d;
  if (/^\d{2}\/\d{2}\/\d{4}$/.test(s)) {
    const [mm, dd, yy] = s.split("/");
    d = new Date(`${yy}-${mm}-${dd}T00:00:00`);
  } else if (/^\d{8}$/.test(s)) d = new Date(`${s.slice(4)}-${s.slice(0, 2)}-${s.slice(2, 4)}T00:00:00`);
  if (!d || isNaN(d.getTime())) return null;
  const now = new Date();
  let age = now.getFullYear() - d.getFullYear();
  const m = now.getMonth() - d.getMonth();
  if (m < 0 || (m === 0 && now.getDate() < d.getDate())) age--;
  return age >= 0 && age < 130 ? age : null;
}
